module.exports = __webpack_public_path__ + "static/media/3 05 Tulleord Falk er riktig-norming.13e20da2.mp3";